import React from 'react';
import {
  Modal,
  Button,
  Form,
  FormGroup,
  Label,
  // Badge,
} from 'reactstrap';

import { ApiContext } from 'src/utils/ApiContext';

import { withNamespaces } from 'react-i18next';

/** @typedef {import('@src/utils/types').RegistData} RegistData */

export default withNamespaces()(ModalRegister);
function ModalRegister(props) {
  const { t } = props;
  const { onRegister } = props;

  const context = React.useContext(ApiContext);

  const uidRef = React.createRef();
  const nicknameRef = React.createRef();
  // const emailRef = React.createRef();
  const passwordRef = React.createRef();
  const widRef = React.createRef();

  // console.log('nameRef', nameRef.current.value)
  // console.log('emailRef', emailRef.current.value)
  // console.log('passwordRef', passwordRef.current.value)
  // console.log('uidRef', uidRef.current.value)

  return (
    <Modal
      isOpen={context.showRegister}
      toggle={() => context.setShowRegister(false)}
      zIndex={1}
    >
      <Form style={{ padding: 20 }}>
        <FormGroup>
          <Label for={'register-uid'}>{t('ModalRegister.GameCenterAccount')}</Label>
          <input
            ref={uidRef}
            type={'text'}
            name={'uid'}
            pattern={'^(?=.*[a-z])(?=.*\\d)[a-z\\d]{6,15}$'}
            id={'register-uid'}
            placeholder={t('ModalRegister.PleaseEnterYourGameCenterAccount')}
            style={{ width: '100%' }}
          />
        </FormGroup>
        <FormGroup>
          <Label for={'register-nickname'}>{t('ModalRegister.Nickname')}</Label>
          <input
            ref={nicknameRef}
            type={'text'}
            name={'nickname'}
            maxLength={32}
            id={'register-nickname'}
            placeholder={t('ModalRegister.PleaseEnterYourNickName')}
            style={{ width: '100%' }}
          />
        </FormGroup>
        {/* <FormGroup>
          <Label for={'register-email'}>{'信箱'}</Label>
          <input
            ref={emailRef}
            type={'email'}
            name={'email'}
            id={'register-email'}
            placeholder={'請輸入您的暱稱'}
            style={{ width: '100%' }}
          />
        </FormGroup> */}
        <FormGroup>
          <Label for={'register-password'}>{t('ModalRegister.Password')}</Label>
          <input
            ref={passwordRef}
            type={'password'}
            name={'password'}
            id={'register-password'}
            placeholder={t('ModalRegister.PleaseEnterYourPassword')}
            style={{ width: '100%' }}
          />
        </FormGroup>

        {/* 沒這種東西
        <FormGroup tag="fieldset">
          <div>
            <Badge color="primary">
              {t('ModalRegister.PayConnection')}
            </Badge>
          </div>
          <hr></hr>
          <h6>{t('ModalRegister.PayConnectionDescription')}</h6>
        </FormGroup>

        <FormGroup>
          <Label for={'register-wid'}>{t('ModalRegister.PayAccount')}</Label>
          <input
            ref={widRef}
            type={'text'}
            pattern={'^(?=.*[a-z])(?=.*\\d)[a-z\\d]{6,15}$'}
            name={'wid'}
            maxLength={200}
            id={'register-wid'}
            placeholder={t('ModalRegister.PleaseEnterYourPayAccount')}
            style={{ width: '100%' }}
          />
        </FormGroup>
        */}

        <Button
          onClick={() => {

            /** @type {RegistData} */
            const newUser = {
              uid: uidRef.current.value,
              password: passwordRef.current.value,
              nickname: nicknameRef.current.value,
              wid: widRef.current?.value ?? '',
            };

            return onRegister(newUser)
          }}
        >
          {t('ModalRegister.Regist')}
        </Button>
      </Form>
    </Modal >
  );
};
